import styled from 'styled-components';
import {JColors} from 'themes/colors';

export const Container = styled.div``;
export default {
  Field: {
    color: '#707070',
    fontWeight: 'bold',
    fontSize: '12px',
    marginBottom: '10px',
  },
  container: {
    padding: '20px',
  },
  headerTitle: {
    fontFamily: 'AvenirNext-Medium',
    fontSize: '18px',
    lineHeight: '1.3em',
    color: '#4a4a4a',
    marginBottom: '20px',
  },
  GroupPanel: {
    marginBottom: '20px',
  },
  TextField: {
    display: 'block',
    resize: 'vertical',
    minHeight: '135px',
    backgroundColor: '#FFF',
    fontSize: '17px',
    boxSizing: 'border-box',
    borderRadius: '3px',
    padding: '4px 14px 4px 8px',
    border: 'solid 1px #ccc',
  },
  FieldButton: {
    marginLeft: '10px',
  },
  buttonControl: {
    minWidth: '150px',
    padding: '0px',
  },
};
